import React from "react";
import classes from "./ResourceFooter.scss";
import { Button } from "@toddle-edu/ds-web";

class ResourceFooter extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.leftPane}>
          <div className={classes.selectedText}>
            {`${this.props.totalSelected} selected`}
          </div>
        </div>
        <div className={classes.rightPane}>
          <Button
            variant={"outlined"}
            className={classes.rightPaneButtons}
            onClick={this.props.onCancelClick}
          >
            {t("cancel")}
          </Button>

          <Button
            variant={"progressive"}
            disabled={this.props.totalSelected == 0}
            onClick={this.props.onAddClick}
          >
            {t("add")}
          </Button>
        </div>
      </div>
    );
  }
}

export default ResourceFooter;
